import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayModule } from "@angular/cdk/overlay";
import { DsAccordionComponent } from "./ds-accordion.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsAccordionComponent],
  imports: [CommonModule, OverlayModule, DsIconModule],
  exports: [DsAccordionComponent],
})
export class DsAccordionModule {}
